import React from "react";
import { CircularProgress, Stack } from "@mui/material";
import { StepButton } from "../types/merchantRegister.types";
import { Button } from "../../../../components";

interface MerchantStepButtonsProps {
  previousBtn?: StepButton;
  nextBtn?: StepButton;
}

export const MerchantStepButtons: React.FC<MerchantStepButtonsProps> = ({
  previousBtn,
  nextBtn,
}) => {
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{ mt: 4, width: "100%", justifyContent: previousBtn ? "space-between" : "flex-end" }}
    >
      {previousBtn && (
        <Button
          onClick={previousBtn.onClick}
          disabled={previousBtn.disabled || previousBtn.loading}
        >
          {previousBtn.loading && (
            <CircularProgress
              size={18}
              sx={{ mr: 1 }}
            />
          )}
          {previousBtn.label}
        </Button>
      )}

      {nextBtn && (
        <Button
          onClick={nextBtn.onClick}
          disabled={nextBtn.disabled || nextBtn.loading}
        >
          {nextBtn.loading && (
            <CircularProgress
              size={18}
              color="inherit"
              sx={{ mr: 1 }}
            />
          )}
          {nextBtn.label}
        </Button>
      )}
    </Stack>
  );
};

export default MerchantStepButtons;
